<template>
	<div
		class="rule-row"
		role="listitem"
		:data-testid="`pass-${passNumber}-rule-${rule.id || `new-${index}`}`"
	>
		<div class="rule-field">
			<span class="rule-field-dot" />
			{{ rule.fieldName }}
		</div>
		<div
			class="rule-behavior"
			:aria-label="`Behavior: ${behaviorText}`"
		>
			{{ behaviorText }}
		</div>
		<div
			class="rule-status"
			:class="rule.isActive ? 'rule-status--active' : 'rule-status--inactive'"
		>
			{{ (rule.isActive ? 'Active' : 'Inactive') | useLabels }}
		</div>
		<v-menu
			v-if="userFullPermissions"
			offset-y
			left
		>
			<template #activator="{ on, attrs }">
				<v-btn
					icon
					small
					v-bind="attrs"
					:aria-label="`Actions for rule ${rule.fieldName}`"
					:data-testid="`pass-${passNumber}-rule-${rule.id || `new-${index}`}-menu`"
					v-on="on"
					@click.stop
				>
					<v-icon>
						mdi-dots-horizontal
					</v-icon>
				</v-btn>
			</template>
			<v-list dense>
				<v-list-item @click="$emit('edit')">
					<v-list-item-title>
						{{ 'Edit' | useLabels }}
					</v-list-item-title>
				</v-list-item>
				<v-list-item @click="$emit('duplicate')">
					<v-list-item-title>
						{{ 'Duplicate' | useLabels }}
					</v-list-item-title>
				</v-list-item>
				<v-list-item @click="$emit('toggle-active')">
					<v-list-item-title>
						{{ (rule.isActive ? 'Deactivate' : 'Activate') | useLabels }}
					</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</div>
</template>

<script>
import { behaviorTextFromFlags } from '../utils/behavior-options.js'

export default {
	name: 'pass-card-rule-row',
	props: {
		rule: { type: Object, required: true },
		passNumber: { type: Number, required: true },
		index: { type: Number, default: 0 },
		userFullPermissions: { type: Boolean, default: false }
	},
	computed: {
		behaviorText () {
			return behaviorTextFromFlags(this.rule.allowBlanks, this.rule.mustBeBlank)
		}
	}
}
</script>

<style scoped>
/* Grid columns assume desktop width; responsive stacking is owned by PassCard. */
.rule-row {
	display: grid;
	grid-template-columns: 1fr minmax(220px, 1.6fr) 90px 32px;
	align-items: center;
	padding: 12px 20px;
	border-bottom: 1px solid var(--border);
	gap: 12px;
}
.rule-row:last-child { border-bottom: none; }
.rule-field { font-size: var(--font-size-sm); font-weight: var(--font-weight-medium); }
.rule-field-dot {
	display: inline-block;
	width: 6px; height: 6px;
	background: var(--primary);
	border-radius: var(--radius-full);
	margin-right: 8px;
	vertical-align: middle;
}
.rule-behavior {
	font-size: var(--font-size-sm);
	color: var(--foreground);
}
.rule-status {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	justify-self: center;
	font-size: var(--font-size-xs);
	padding: 2px 8px;
	border-radius: var(--radius-full);
	font-weight: var(--font-weight-medium);
}
.rule-status--active { background: var(--success-light); color: var(--success); }
.rule-status--inactive { background: var(--muted); color: var(--muted-foreground); }
</style>
